<template>
  <v-tooltip bottom :disabled="!hasTooltip">
    <template #activator="{ on, attrs }">
      <div class="icon-badge-container" v-bind="attrs" v-on="on">
        <div class="badge-icon" :class="iconBgClass">
          <v-icon
            small
            :color="iconColor"
            class="material-icons-outlined"
          >
            {{ icon }}
          </v-icon>
        </div>
        <div
          class="icon-badge-text caption font-weight-medium"
          :class="[labelBgClass, labelClass]"
        >
          <slot>{{ label }}</slot>
        </div>
      </div>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'IconBadge',
  props: {
    label: {
      type: [String, Number],
      required: true,
    },
    labelBgClass: {
      type: String,
      default: 'grey lighten-3',
    },
    labelClass: {
      type: String,
      default: 'grey--text text--darken-2',
    },
    icon: {
      type: String,
      default: 'add',
    },
    iconBgClass: {
      type: String,
      default: 'grey lighten-2',
    },
    iconColor: {
      type: String,
      default: 'grey darken-2',
    },
    tooltip: {
      type: String,
      default: null,
    },
    tooltipDirection: {
      type: String,
      default: 'bottom',
    },
  },
  computed: {
    hasTooltip() {
      return this.tooltip !== null;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon-badge-container {
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

.badge-icon {
  border-radius: 4px 0px 0px 4px;
  width: 24px;
  padding-bottom: 2px;
  text-align: center;
  vertical-align: middle;
}

.icon-badge-text {
  border-radius: 0px 4px 4px 0px;
  padding-left: 0.75em;
  padding-right: 0.75em;
  padding-top: 1px;
  padding-bottom: 1px;

  display: flex;
  align-items: center;
}
</style>
